module.exports = __webpack_public_path__ + "static/sport/banner2.9a934cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newldp/banner2.png
// module id = DSVp
// module chunks = 0